// Shared error-message extraction for Wealthbox create/edit modal submit
// handlers. Wealthbox API errors get surfaced through executeWealthboxRequest
// in core-data, which wraps the upstream Wealthbox body in a Boom error and
// returns it as a 502 with the original message preserved at
// `response.data.message`. JavaScript-side validation failures (e.g. yup,
// react-hook-form) surface as plain `Error.message`. Network / unexpected
// failures hit the fallback string the caller supplies.

export function extractWealthboxErrorMessage (err, fallback) {
  return err?.response?.data?.message || err?.message || fallback
}
